<template>
  <div>
    <banner></banner>
    <div class="seeding">
      <div class="center-banner">
        <el-carousel :interval="4000" height="400px">
          <el-carousel-item v-for="item in data.banner" :key="item.id">
            <div class="tite_box">
              <h6>{{ item.name }}</h6>
              <p>{{ item.description }}</p>
            </div>
            <div class="banner-item">
              <img v-for="i in item.url.split(',')" :key="i" :src="i" />
            </div>
            <!-- <h3 text="2xl" justify="center">{{ item }}</h3> -->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="service">
      <div class="center-banner flex" style="justify-content: space-between">
        <div class="service_left">
          <div class="service_ul">
            <!-- <div class="service_li">
                            <img :src="$httpImg + '/img/icon/icon_index1.png'" />
                            <div>
                                <h6>超拼服务</h6>
                                <p>超级能拼，一网打尽</p>
                            </div>
                        </div>
                        <div class="service_li">
                            <img :src="$httpImg + '/img/icon/icon_index2.png'" />
    
                            <div>
                                <h6>医药健康</h6>
                                <p>超拼云药房，品质好药，守护健康</p>
                            </div>
                        </div>
                        <div class="service_li">
                            <img :src="$httpImg + '/img/icon/icon_index3.png'" />
                            <div>
                                <h6>农产品产地直发</h6>
                                <p>从源头产地到消费者餐桌，去除中间商</p>
                            </div>
                        </div>
                        <div class="service_li">
                            <img :src="$httpImg + '/img/icon/icon_index4.png'" />
                            <div>
                                <h6>电商+视频直播</h6>
                                <p>新鲜看得见，买的才放心</p>
                            </div>
                        </div>
                        <div class="service_li">
                            <img :src="$httpImg + '/img/icon/icon_index5.png'" />
                            <div>
                                <h6>严选好物</h6>
                                <p>专注严选好货，和源头药厂，源头厂家合作</p>
                            </div>
                        </div> -->
            <div
              v-for="i in data.service"
              :key="i.img"
              class="service_li"
              @mouseover="handChange(i)"
              @click="handChange(i)"
            >
              <img class="show" :src="i.ico" />
              <img class="hide" :src="i.icoh" />
              <div>
                <h6>{{ i.name }}</h6>
                <p>{{ i.description }}</p>
              </div>
            </div>
          </div>
          <img
            :src="$httpImg + '/img/icon/mascot.png'"
            class="mascot trans_foo_b"
          />
        </div>
        <div class="service_right">
          <div>
            <img :src="data.enterImg.backgroundArr[2]" class="trans" />
            <img :src="data.enterImg.backgroundArr[3]" class="trans_bottom" />
            <img
              :src="data.enterImg.backgroundArr[4]"
              class="trans_bottom_left"
            />
          </div>
          <div>
            <img :src="data.enterImg.goodsPic" style="width: 303px;" />
          </div>
          <div class="flex_ccolumn">
            <img :src="data.enterImg.backgroundArr[1]" class="trans_foo" />
            <img :src="data.enterImg.backgroundArr[0]" class="trans" />
          </div>
        </div>
      </div>
    </div>
    <div class="news">
      <div class="center-banner">
        <h6>新闻中心</h6>
        <div class="ul">
          <div
            v-for="i in data.newsList"
            :key="i"
            class="li"
            @click="goto('/details', i.id)"
          >
            <p style="text-align: left">{{ i.title }}</p>
            <span>
              {{ i.intro }}&nbsp;&nbsp;&nbsp;&nbsp;{{ i.createTime }}
            </span>
          </div>
        </div>
        <div class="buttonsMore" @click="goto('/news')">更多新闻</div>
      </div>
    </div>

    <div class="cooperation">
      <div class="center-cooperation" v-if="data.brand[0]">
        <h6>合作品牌</h6>
        <div class="ulbox_show">
          <div
            class="ulbox"
            :style="{ transform: `translate(${data.transform}px, 0px)` }"
          >
            <div class="ul">
              <div class="li" v-for="i in data.brandList" :key="i">
                <img
                  v-for="item in i.url "
                  :src="item"
                  :key="item + ' 1-1'"
                />
              </div>

              <!-- <img v-for="i in data.brand" :src="i.url" :key="i" /> -->
            </div>
            <div class="ul">
              <div class="li" v-for="i in data.brandList" :key="i + 1">
                <img
                  v-for="item in i.url "
                  :src="item"
                  :key="item + ' 1-1'"
                />
              </div>
            </div>
          </div>
          <div class="mask-normal mask-left pos-absolute"></div>
          <div class="mask-normal mask-right pos-absolute"></div>
        </div>
      </div>
    </div>
    <div class="enterbox">
      <div class="center-banner">
        <h6>商家入驻新模式</h6>
        <div class="ul">
          <div v-for="i in data.enter" :key="i.id" class="li">
            <img :src="i.configValue" />
            <p
              style="
                width: 100px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                text-align: center;
              "
            >
              {{ i.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { onMounted } from "vue";
import banner from "@/components/banner.vue";
import myFooter from "@/components/myFooter.vue";
import {
  getbanner,
  getrichTextlist,
  getconfig,
  getsimpleGroup,
} from "@/comm/api";
import { useRouter } from "vue-router";
export default {
  components: {
    banner,
    myFooter,
  },
  setup() {
    let data = reactive({
      serviceIndex: 0,
      banner: [],
      brand: [],
      brandList:[
        {
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00016.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00017.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00018.png']
        },{
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/%E7%AB%8B%E7%99%BD.jpg','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/%E6%B4%81%E6%9F%94.jpg','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/999.jpg']
        },{
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00020.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00022.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00024.png']
        },{
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/%E6%A4%8D%E6%8A%A4.jpg','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/%E5%8F%8C%E6%B1%87.jpg','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/img/%E6%B8%85%E9%A3%8E.jpg']
        },{
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00014.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00017.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/pinpai00018.png']
        }, {
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E7%88%B1%E9%BA%A6%E9%A3%9F%E5%93%81%281%29_1721457485292.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E8%8D%89%E6%9C%A8%E7%BE%8A%281%29_1721457543577%20%281%29.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E6%9C%AC%E6%BA%90%E4%B9%B3%E6%B6%B2%281%29_1721457515744.png']
        },{
          url:['https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E6%B7%BB%E5%AE%9D%281%29_1721457629509.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E5%A8%9C%E6%8B%89%E9%9B%86%E5%9B%A2%281%29_1721457583659.png','https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com/%E4%BA%AB%E6%8A%98%E6%B1%87%281%29_1721457649149.png']
        }
      ],
      chaoPinLink: "",
      transform: 0,
      service: [
        {
          title: "超拼服务",
          subheading: "超级能拼，一网打尽",
          img: "@/assets/img/icon/icon_index1.png",
        },
        {
          title: "医药健康",
          subheading: "超拼云药房，品质好药，守护健康",
          img: "@/assets/img/icon/icon_index2.png",
        },
        {
          title: "农产品产地直发",
          subheading: "从源头产地到消费者餐桌，去除中间商",
          img: "@/assets/img/icon/icon_index3.png",
        },
        {
          title: "电商+视频直播",
          subheading: "新鲜看得见，买的才放心",
          img: "@/assets/img/icon/icon_index4.png",
        },
        {
          title: "严选好物",
          subheading: "专注严选好货，和源头药厂，源头厂家合作",
          img: "@/assets/img/icon/icon_index5.png",
        },
      ],
      newsList: [],
      enter: [],
      enterImg: {
        background: "",
        backgroundArr: [],
      },
    });
    const hanransform = () => {
      setInterval(() => {
        if (data.transform != "-1564") {
          data.transform--;
        } else {
          data.transform = 0;
        }
      }, 10);
    };
    const getbannerList = async (type) => {
      try {
        const res = await getbanner({ type: type });
        console.log(1, res);
        if (res.code == 1) {
          if (type == 4) {
            data.banner = res.data;
          } else if (type == 3) {
            data.brand = res.data;
          } else if (type == 6) {
            data.service = res.data;
            data.service.map((i) => {
              i.ico = i.url.split(",")[0];
              i.icoh = i.url.split(",")[1];
              i.backgroundArr = i.background.split(",");
            });
            data.enterImg = data.service[0];
          }
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    const handChange = (item) => {
      data.enterImg = { ...item };
    };
    const getrichText = async () => {
      try {
        const res = await getrichTextlist({ pageNo: 1, pageSize: 5 });
        console.log(1, res);
        if (res.code == 1) {
          data.newsList = res.data.records;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    const getconfigFn = async (configName) => {
      try {
        const res = await getconfig({ configName: configName });
        console.log(1, res);
        if (res.code == 1) {
          data[configName] = res.data;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    const getconfigGroup = async (configName) => {
      try {
        const res = await getsimpleGroup({ groupName: configName });
        console.log(1, res);
        if (res.code == 1) {
          data[configName] = res.data;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    const router = useRouter();
    const goto = (path, id) => {
      if (id) {
        router.push({ path: path, query: { id: id } });
      } else {
        router.push(path);
      }
    };
    function browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();

      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";

      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";

      var bIsMidp = sUserAgent.match(/midp/i) == "midp";

      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";

      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";

      var bIsAndroid = sUserAgent.match(/android/i) == "android";

      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";

      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

      // document.writeln("您的浏览设备为：");

      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        router.push({ path: '/download', });
      } else {
       
      }
    }

   
    onMounted(() => {
      getbannerList(4);
      getbannerList(3);
      // getbannerList(3)
      getbannerList(6);
      getrichText();
      getconfigFn("chaoPinLink"), getconfigGroup("enter");
      hanransform();
      browserRedirect();
    });
    return {
      data,
      getbannerList,
      getconfigFn,
      getconfigGroup,
      goto,
      handChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.seeding {
  width: 100%;
  height: 450px;
  z-index: 9;
  padding-top: 5%;
  position: relative;
  background: url("../../assets/img/bag/bg2.png") no-repeat;
  background-size: 100% 100%;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.center-banner {
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;
}

.banner-item {
  display: flex;
  align-items: center;

  img {
    width: 30%;
    margin: 20px;
    border-radius: 20px;
  }
}

.flex {
  display: flex;
  align-items: center;
}

.flex_ccolumn {
  display: flex;
  flex-direction: column;
}

.tite_box {
  text-align: center;

  h6 {
    font-weight: bold;
    font-size: 26px;
    color: #000000;
    margin-bottom: 10px;
  }

  p {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
  }
}

.el-carousel__item:nth-child(2n) {
  // background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  // background-color: #d3dce6;
}

:deep(.el-carousel__button) {
  width: 5px !important;
  height: 5px !important;
  border-radius: 50%;
  background: #dcdcdc;
}

.show {
  display: block;
}

.hide {
  display: none !important;
}

.service {
  width: 100%;
  height: 700px;
  z-index: 9;
  padding-top: 5%;
  position: relative;
  background: #fff url("../../assets/img/bag/bg-3.png") no-repeat;
  background-size: 100% 100%;

  .service_right {
    display: flex;
  }

  .mascot {
    transform: translateY(25px);
  }

  .service_ul {
    .service_li:hover {
      background: #ffffff;
      color: #38c9c8;
      border-radius: 20px;
    }

    .service_li {
      display: flex;
      align-items: center;
      padding: 18px;
      cursor: pointer;

      h6 {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
      }

      p {
        font-family: Microsoft YaHei;
        font-weight: 300;
        font-size: 14px;
        color: #fff;
      }

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
  }
}

.service_li:hover h6 {
  color: #38c9c8 !important;
}

.service_li:hover p {
  color: #38c9c8 !important;
}

.service_li:hover .hide {
  display: block !important;
}

.service_li:hover .show {
  display: none !important;
}
.service_li:active h6 {
  color: #38c9c8 !important;
}

.service_li:active p {
  color: #38c9c8 !important;
}

.service_li:active .hide {
  display: block !important;
}

.service_li:active .show {
  display: none !important;
}
.news {
  width: 100%;
  height: 600px;
  z-index: 9;
  position: relative;
  background: #fff;
  padding-top: 50px;

  h6 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 26px;
    color: #333333;
    text-align: center;
    margin-bottom: 30px;
  }

  .ul {
    .li {
      display: flex;
      justify-content: space-between;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #555555;
      padding: 30px;
    }
  }

  .buttonsMore {
    background: #38c9c8;
    border-radius: 15px;
    width: 121px;
    height: 30px;
    margin: 0 auto;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
    margin-top: 30px;
  }
}

.cooperation {
  width: 100%;
  // height: 630px;
  z-index: 9;
  position: relative;
  background: #fff;
  padding-top: 0px;

  .center-cooperation {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 30px;

    overflow: hidden;

    h6 {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 26px;
      color: #333333;
      text-align: center;
      margin-bottom: 30px;
    }

    .mask-left {
      left: 0;
      top: 0;
      background: -webkit-gradient(
        linear,
        right top,
        left top,
        from(hsla(0, 0%, 100%, 0)),
        to(#fff)
      );
      background: linear-gradient(270deg, hsla(0, 0%, 100%, 0) 0, #fff);
    }
    .mask-right {
      right: 0;
      top: 0;
      background: linear-gradient(90deg, hsla(0, 0%, 100%, 0) 0, #fff);
    }
   .mask-normal {
      height: 100%;
      width: 200px;
      position: absolute;
   
    }
    .ulbox {
      transition: ease-in;
      overflow: hidden;
      width: 3137px;
      display: flex;
      background-color: #fff;
    }
    .ul {
      width: 50%;
      //   float: left;
      display: flex;
      overflow: hidden;
      //   display: flex;
      //   flex-wrap: wrap;
      //   justify-content: space-evenly;

      img {
        width: 196px;
        height: 127px;
        padding: 20px 10px;
      }
    }
  }
}

.enterbox {
  width: 100%;
  // height: 500px;
  z-index: 9;
  position: relative;
  background: #f9f9f9;
  padding-top: 50px;

  h6 {
    font-weight: bold;
    font-size: 26px;
    color: #000000;
    margin-bottom: 10px;
    text-align: center;
  }

  .ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    margin-top: 40px;
    border-radius: 10px;

    .li {
      padding: 40px;
      background: white;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 30px;

      img {
        margin-bottom: 20px;
      }
    }
  }
}

.trans {
  width: 150px;
  /* 引入动画(1.3s可控制速度) */
  animation: heart 4s linear 0s infinite alternate;
  /* END */
}
.trans_bottom {
  width: 150px;
  position: absolute;
  bottom: 60px;
  right: 50%;
  /* 引入动画(1.3s可控制速度) */
  animation: heart_foo 4s linear 0s infinite alternate;
  /* END */
}
.trans_bottom_left {
  width: 150px;
  position: absolute;
  bottom: 60px;
  right: 10%;
  /* 引入动画(1.3s可控制速度) */
  animation: heart_foo 4s linear 0s infinite alternate;
  /* END */
}
.trans_foo {
  width: 150px;
  /* 引入动画(1.3s可控制速度) */
  animation: heart_foo 4s linear 0s infinite alternate;
  /* END */
}

.trans_foo_b {
  /* 引入动画(1.3s可控制速度) */
  animation: heart_foo 4s linear 0s infinite alternate;
  /* END */
}

@keyframes heart {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(40px);
  }

  /* 下浮高度 */
}

@keyframes heart_foo {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-40px);
  }

  /* 下浮高度 */
}
</style>